import cn from "classnames"

import { CellTable } from "@/atoms"

import styles from "./IconTextCell.module.scss"

import type { IconTextCellProps } from "."

export const IconTextCell = (props: IconTextCellProps) => {
  const {
    icon,
    text,
    description,
    noTooltip,
    variant,
    iconPosition = "start",
    classes = {}
  } = props
  const cellTableProps = { noTooltip }
  const iconNode = <span className={cn(styles.icon, classes.icon)}>{icon}</span>

  return (
    <div className={cn(styles.container, classes.container)}>
      {iconPosition === "start" && iconNode}
      {description ? (
        <span className={styles.textContainer}>
          {CellTable(text, cellTableProps)}
          <span
            className={cn(styles.description, {
              [styles.descriptionRegular]: variant === "regular"
            })}
          >
            {description}
          </span>
        </span>
      ) : (
        CellTable(text, cellTableProps)
      )}
      {iconPosition === "end" && iconNode}
    </div>
  )
}
